import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enprofile from "../src/locales/profile/en/profile.json";
import arprofile from "../src/locales/profile/ar/profile.json";
import enaddvenue from "../src/locales/addvenue/en/addvenue.json";
import araddvenue from "../src/locales/addvenue/ar/addvenue.json";
import envenue from "../src/locales/venues/en/venues.json";
import arvenue from "../src/locales/venues/ar/venues.json";
import enaddons from "../src/locales/addons/en/addons.json";
import araddons from "../src/locales/addons/ar/addons.json";
import encatering from "../src/locales/addons/en/catering.json";
import arcatering from "../src/locales/addons/ar/catering.json";
import enfacilty from "../src/locales/addons/en/facility.json";
import arfacilty from "../src/locales/addons/ar/facility.json";

import endish from "../src/locales/addons/en/dish.json";
import ardish from "../src/locales/addons/ar/dish.json";

import enbooking from "../src/locales/booking/en/booking.json";
import arbooking from "../src/locales/booking/ar/booking.json";

import endash from "../src/locales/dashboard/en/dashboard.json";
import ardash from "../src/locales/dashboard/ar/dashboard.json";

import enattraction from "../src/locales/attraction/en/attraction.json";
import arattraction from "../src/locales/attraction/ar/attraction.json";

import enlogin from "../src/locales/login/en/login.json";
import arlogin from "../src/locales/login/ar/login.json";

import ennavbar from "../src/locales/navbar/en/navbar.json";
import arnavbar from "../src/locales/navbar/ar/navbar.json";

import enplace from "../src/locales/place/en/place.json";
import arplace from "../src/locales/place/ar/place.json";
import enchat from "../src/locales/chat/en/chat.json";
import archat from "../src/locales/chat/ar/chat.json";

import enorganizers from "../src/locales/organizers/en/organizers.json";
import arorganizers from "../src/locales/organizers/ar/organizers.json";

const savedLanguage = localStorage.getItem("language") || "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        profile: enprofile,
        addvenue: enaddvenue,
        venue: envenue,
        addons: enaddons,
        catering: encatering,
        facilty: enfacilty,
        dish: endish,
        booking: enbooking,
        dash: endash,
        attraction: enattraction,
        login: enlogin,
        navbar: ennavbar,
        place: enplace,
        chat: enchat,
        organizers: enorganizers,
      },
      ar: {
        profile: arprofile,
        addvenue: araddvenue,
        venue: arvenue,
        addons: araddons,
        catering: arcatering,
        facilty: arfacilty,
        dish: ardish,
        booking: arbooking,
        dash: ardash,
        attraction: arattraction,
        login: arlogin,
        navbar: arnavbar,
        place: arplace,
        chat: archat,
        organizers: arorganizers,
      },
    },
    lng: savedLanguage,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
